<template>
	<div class="history-bg" style="padding: 0; height: 100%; width: 100%; position: relative">
		<div class="" id="trfl" style="height: 100%; width: 100%"></div>
	</div>
</template>

<script>
	import * as echarts from "echarts";
	import "echarts-gl";
	export default {
		data() {
			return {
				interVal: "",
				myChart: null,
				app: {
					currentIndex: -1,
				},
				dispatchTimer: null,
				dataLen: null,
			};
		},
		mounted() {
			// this.requestData(500)
			// this.generateRecentWeekDates()
			this.init();
		},
		methods: {
			generateRecentWeekDates() {
				const dates = [];
				const today = new Date();
				// 获取六天前的日期作为起始点
				const startDate = new Date(today);
				startDate.setDate(today.getDate() - 6);

				// 循环7天，逐日递增
				for (let i = 0; i < 7; i++) {
					const currentDate = new Date(startDate);
					currentDate.setDate(startDate.getDate() + i);

					// 格式化为MM-DD
					const month = String(currentDate.getMonth() + 1).padStart(2, "0");
					const day = String(currentDate.getDate()).padStart(2, "0");
					dates.push(`${month}-${day}`);
				}

				return dates;
			},
			requestData(number, area, tulongNum, beforeMoney, afterMoney) {
				this.$request(
					"center/newService1/farmLines?num=" +
					number +
					"&area=" +
					area +
					"&tulongNum=" +
					tulongNum +
					"&beforeMoney=" +
					beforeMoney +
					"&afterMoney=" +
					afterMoney
				).then((res) => {
					if (this.myChart) {
						clearInterval(this.dispatchTimer);
						this.myChart.clear();
					}
					for (var i = 0; i < res.data.length; i++) {
						if (res.data[i].type == 1) {
							this.init(res.data[i].list);
						}
					}
				});
			},
			init(pageData, type) {
				let that = this;
				that.myChart = echarts.init(document.getElementById("trfl"));

				//随着屏幕大小调节图表
				window.addEventListener("resize", () => {
					that.myChart.resize();
				});
				// 定义一个变量 s1_data，用于存储饼图的数据
				var s1_data = [{
						value: 54,
						name: '氮'
					}, {
						value: 13,
						name: '磷'
					},
					{
						value: 89,
						name: '钾'
					}
				];



				// 定义一个变量 colorStops，用于存储颜色渐变的停止点
				var colorStops = [
					[{
							offset: 0,
							color: 'rgba(21, 228, 255, 0.20)' // 0% 处的颜色
						},
						{
							offset: 1,
							color: 'rgba(138, 212, 255, 1)' // 100% 处的颜色
						}
					],
					[{
							offset: 0,
							color: 'rgba(138, 255, 165, 0.2)' // 0% 处的颜色
						},
						{
							offset: 1,
							color: 'rgba(138, 255, 165, 1)' // 100% 处的颜色
						}
					],
					[{
							offset: 0,
							color: 'rgba(255, 248, 101, 0.2)' // 0% 处的颜色
						},
						{
							offset: 1,
							color: 'rgba(255, 248, 101, 1)' // 100% 处的颜色
						}
					],
					[{
							offset: 0,
							color: 'rgba(253, 167, 62, 0.20)' // 0% 处的颜色
						},
						{
							offset: 1,
							color: 'rgba(249, 110, 29, 1)' // 100% 处的颜色
						}
					],

				];

				// 定义一个变量 l_data，用于存储图例的数据
				var l_data = [];

				// 遍历 s1_data，将每个数据项的 name 属性添加到 l_data 中
				s1_data.forEach((data) => {
					l_data.push(data.name)
				});

				// 定义一个变量 option，用于存储图表的配置项
				var option = {
					// title: [{ // 圆环中间内容
					// 	text: '100',
					// 	left: "30%",
					// 	top: "40%",
					// 	textStyle: {
					// 		color: "#13E1EB",
					// 		fontSize: 24,
					// 		align: "center"
					// 	},
					// }, {
					// 	text: '亿',
					// 	left: "36%",
					// 	top: "41%",
					// 	textStyle: {
					// 		fontSize: 10,
					// 		align: "center",
					// 		color: '#fff'
					// 	},
					// }, {
					// 	text: '总资产',
					// 	left: "27%",
					// 	top: "51%",
					// 	textStyle: {
					// 		fontSize: 30,
					// 		fontWeight: '700',
					// 		align: "center",
					// 		color: '#fff'
					// 	},
					// }],

					tooltip: {
						trigger: 'item',
						formatter: `{b}:{c}mg/kg`,
					},

					grid: {
						left: "20%",
						top: "10%",
						right: "0%",
						bottom: "22%"
					},
					// 图例
					legend: {
						show: true,
						type: 'scroll',
						icon: 'circle',
						orient: 'vertical', // 图例左侧上下排布
						left: '75%',
						top: 'center',
						textStyle: {
							fontSize: 12,
							color: '#fff',
						},
						itemWidth: 14,
						pageIconColor: '#fff', // 图例翻页样式设置
						pageIconSize: 10,
						pageTextStyle: {
							fontSize: 10,
							color: '#fff'
						},
						data: l_data
					},
					// 中心图片
					//  graphic: {
					//      elements: [{
					//          type: "image",
					//          z: 5,
					//          style: {
					//              image: img,
					//              width: 95,
					//              height: 95
					//          },
					//          left: '23%',
					//          top: "center"
					//      }]
					//  },

					series: [{
							name: '总资产',
							type: 'pie',
							radius: '80%',
							center: ['35%', '50%'], // 饼图在画布中的位置
							radius: ['30%', '50%'], // 环形大小
							silent: false, // 是否响应鼠标事件

							data: s1_data,
							avoidLabelOverlap: true, // 防止标签重叠
							showEmptyCircle: true,
							itemStyle: {
								normal: {
									borderType: 'solid',
									borderColor: '#1E3477',
									borderRadius: '80%',
									borderWidth: 2, // 饼图间隔距离
									position: 'inside',
									label: {
										padding: [0, 0],
										show: true,
										//环形数值显示样式格式
										formatter: `{a|{c}mg/kg}\n{hr|}\n{a|{d}%}`,
										rich: {
											a: {
												fontSize: 13,
												padding: [3, 0, 5, 0],
												color: 'rgba(20, 233, 250, 1)'
											},
											hr: {
												borderColor: '#fff',
												width: '100%',
												borderWidth: 0.8,
												height: 0,
											},
										}
									},
									//环形指向线条
									labelLine: {
										showAbove: true,
										show: true,
										length2: 0,
										lineStyle: {
											color: '#fff',
										}
									},
									//渲染环形渐变色
									color: function(params) {
										return {
											//type: 'linear',
											x: 0,
											y: 1,
											x2: 1,
											y2: 0,
											colorStops: colorStops[params.dataIndex], // 100% 处的颜色
											//globalCoord: false // 缺省为 false
										}
									},

								},

							},

						},

					]
				}



				that.dataLen = option.series[0].data.length;
				// that.dispatchActions()

				that.myChart.setOption(option);
				// this.interVal = setInterval(function () {
				//     that.myChart.clear()
				//     that.myChart.setOption(option);
				// }, 240000)
				// 20000
			},
			dispatchActions() {
				let that = this;
				that.dispatchTimer = setInterval(function() {
					// 取消之前高亮的图形
					that.myChart.dispatchAction({
						type: "downplay",
						seriesIndex: 0,
						dataIndex: that.app.currentIndex,
					});
					that.app.currentIndex = (that.app.currentIndex + 1) % that.dataLen;
					//console.log(app.currentIndex);
					// 高亮当前图形
					that.myChart.dispatchAction({
						type: "highlight",
						seriesIndex: 0,
						dataIndex: that.app.currentIndex,
					});
					// 显示 tooltip
					that.myChart.dispatchAction({
						type: "showTip",
						seriesIndex: 0,
						dataIndex: that.app.currentIndex,
					});
				}, 3000);
			},
			clearDispatchTimer() {
				clearInterval(this.dispatchTimer);
			},
			setDispatchTimer() {
				this.dispatchActions();
			},
		},
		destroyed() {
			clearInterval(this.interVal);
		},
	};
</script>

<style>
</style>